<div class="height-100 bg-col-w">
    <div class="flex-column height-100 _content">
        <div class="p-a-5 _title"
             [class.box-shadow-1]="titleShadow">
            <div class="pos-relative">
                <ng-content select="[modalTitle]"></ng-content>

                <!-- close button -->
                <button class="pos-absolute top-2 right-0"
                        role="button"
                        [attr.aria-label]="'Close' | translate"
                        (click)="close()">
                    <i class="icon-close"
                       [style.line-height.px]="0"
                       aria-hidden="true"></i>
                </button>
            </div>
        </div>

        <!-- body -->
        <div class="custom-scrollbar overflow-x-hidden flex-grow _body"
             [class._lockScrollSpace]="lockScrollSpace"
             style="overflow-y: auto;">
            <ng-content select="[modalBody]"></ng-content>
        </div>

        <!-- footer -->
        <div class="w-12 pos-relative z-1 box-shadow-1">
            <ng-content select="[modalFooter]"></ng-content>
        </div>
    </div>
</div>
